import { Pane, Heading, Text, Button } from 'evergreen-ui';
import { Link } from 'react-router-dom';

const HeroBanner = ({ title, subtitle, buttonText, buttonLink, bgImage, minHeight = 300 }) => {
  return (
    <Pane
      display="flex" flexDirection="column" alignItems="center" justifyContent="center"
      minHeight={minHeight} padding={40} textAlign="center" position="relative"
      style={{
        backgroundImage: bgImage ? `url("${bgImage}")` : 'none',
        backgroundColor: bgImage ? 'transparent' : '#eef2e6', // colore fallback verde chiaro
        backgroundSize: 'cover', backgroundPosition: 'center'
      }}
    >
      {/* Overlay scuro per migliorare la leggibilità del testo */}
      {bgImage && (
        <Pane
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          backgroundColor="rgba(0, 0, 0, 0.4)"
          zIndex={1}
        />
      )}
      
      <Pane zIndex={2} display="flex" flexDirection="column" alignItems="center">
        <Heading size={900} color={bgImage ? 'white' : 'dark'} marginBottom={16} style={{ fontFamily: 'cursive', fontSize: '3rem', textShadow: bgImage ? '2px 2px 4px rgba(0,0,0,0.6)' : 'none' }}>
          {title}
        </Heading>
        {subtitle && <Text size={500} color={bgImage ? 'white' : 'muted'} marginBottom={24} style={{ textShadow: bgImage ? '1px 1px 3px rgba(0,0,0,0.8)' : 'none' }}>{subtitle}</Text>}
        {buttonText && buttonLink && (
          <Button appearance="primary" intent="success" size="large" is={Link} to={buttonLink} marginTop={8}>
            {buttonText}
          </Button>
        )}
      </Pane>
    </Pane>
  );
}

export default HeroBanner;